/* Mini descrições embaixo dos nomes das coleções no menu */
(function () {
  var dataEl = document.getElementById('custom-menu-desc-data');
  if (!dataEl) return;
  var raw;
  try { raw = JSON.parse(dataEl.textContent); } catch (e) { return; }

  function normalize(url) {
    try { return new URL(url, window.location.origin).pathname.replace(/\/$/, '').toLowerCase(); }
    catch (e) { return String(url || '').toLowerCase(); }
  }

  var map = {};
  Object.keys(raw).forEach(function (key) { map[normalize(key)] = raw[key]; });

  var MENU_SELECTOR = '[data-navigation], sidebar-menu, #navigation-mobile';

  function apply() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (a.querySelector('.custom-menu-desc')) continue;
      if (!a.closest(MENU_SELECTOR)) continue;
      var desc = map[normalize(a.getAttribute('href'))];
      if (!desc) continue;
      var span = document.createElement('span');
      span.className = 'custom-menu-desc';
      span.textContent = desc;
      a.classList.add('has-custom-menu-desc');
      a.appendChild(span);
    }
  }

  apply();

  /* O menu do celular é montado depois do carregamento: aplica de novo quando ele aparecer */
  var timer;
  var observer = new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(apply, 150);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
